import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { LookupValuesService } from '../../common/lookup-values.service';

@Injectable({
  providedIn: 'root'
})
export class NewsGetDropDownOptionsResolverService implements Resolve<any>{

    constructor(private lookupvaluesservice: LookupValuesService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return forkJoin(
            this.lookupvaluesservice.GetNewsMessageTypeOptions(),          
        );
    }
}
